export { default } from './pageSpinner';
